import { useVendor } from '@context/VendorContext';
import { useScheduleApi } from '@hooks/api';
import { usePostApi } from '@hooks/api/usePostApi';
import type { ScheduleAddResponse } from 'services/api/types';
import type { PostApiOptions } from 'types/api';
import type { EventSyncRequest } from 'types/schedule';

export function useCreateSchedule(
  options?: Partial<PostApiOptions<ScheduleAddResponse, EventSyncRequest>>
) {
  const api = useScheduleApi();
  const { vendor } = useVendor();

  const { post: createSchedule, isPosting: isCreatingSchedule } = usePostApi({
    getSuccessMessage: () => 'Schedule added to map!',
    request: (params: EventSyncRequest) =>
      api.addEvents(vendor?.id as string, params),
    ...options,
  });

  return {
    isCreatingSchedule,
    createSchedule,
  };
}
